module.exports = __webpack_public_path__ + "img/1.8ffaccf6.png";